import { useState } from "react";
import { api } from "../../lib/api";
import StatusBadge from "../../components/StatusBadge";
import { PageLoading, ErrorState } from "../../components/States";
import { fmtDateTime } from "../../lib/format";
import { useAdminData, SearchBox, FilterSelect, Pager, TableCard, TH } from "./shared";

export default function AdminDrivers() {
  const { data, error, page, setPage, filters, setFilters, reload } = useAdminData(api.adminDrivers);
  const [q, setQ] = useState("");
  const rows = data?.items || [];

  return (
    <div data-testid="admin-drivers-page">
      <div className="flex flex-wrap gap-3 mb-4">
        <SearchBox value={q} onChange={setQ} onSearch={() => setFilters((f) => ({ ...f, q }))} placeholder="Search drivers…" testid="admin-drivers-search" />
        <FilterSelect value={filters.status || ""} onChange={(v) => setFilters((f) => ({ ...f, status: v }))} label="Status filter" testid="admin-drivers-status"
                      options={[["", "All statuses"], ["active", "Active"], ["suspended", "Suspended"]]} />
      </div>
      {error ? <ErrorState body={error} onRetry={reload} /> : !data ? <PageLoading label="Loading drivers…" /> : (
        <>
          <TableCard testid="admin-drivers-table" empty={rows.length === 0 && "No drivers found."}
            head={<><TH>Driver</TH><TH>Bookings</TH><TH>Vehicles</TH><TH>Last booking</TH><TH>Status</TH><TH>Joined</TH></>}>
            {rows.map((u) => (
              <tr key={u.user_id} className="border-b border-[#18181B]" data-testid={`admin-driver-${u.user_id}`}>
                <td className="p-4"><p className="font-semibold">{u.name}</p><p className="text-xs text-zinc-500">{u.email}</p></td>
                <td className="p-4 text-zinc-300 text-xs">{u.bookings_count}</td>
                <td className="p-4 text-zinc-300 text-xs">{u.vehicles_count}</td>
                <td className="p-4 text-xs text-zinc-500">{u.last_booking_at ? fmtDateTime(u.last_booking_at) : "—"}</td>
                <td className="p-4">{u.suspended ? <StatusBadge value="restricted" /> : <StatusBadge value="active" />}</td>
                <td className="p-4 text-xs text-zinc-500">{fmtDateTime(u.created_at)}</td>
              </tr>
            ))}
          </TableCard>
          <Pager page={page} total={data.total} pageSize={data.page_size} onPage={setPage} testid="admin-drivers-pager" />
        </>
      )}
    </div>
  );
}
